import React, { useState, useEffect } from "react";
import moment from 'moment';
import {
    Panel,
    PanelBody,
} from "../../components/panel/panel.jsx";
import { UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import ReactTable from "../../components/custom/ReactTable";
import { useDispatch, useSelector } from "react-redux";
import { ApiKey, WebUrl, ApiUrl } from "../../util/Constant";
import { showResponseMessage } from "../../redux/AppAction";
import ApiEngine from '../../util/ApiEngine.js';

/// <summary>
/// Author : Yong Sheng Chuan
/// </summary>
const Announcement = props => {
    var _dispatch = useDispatch();
    const { t } = useTranslation();
    const [viewModal, setViewModal] = useState(false);
    const [announcementData, setAnnouncementData] = useState([]);
    var _userData = useSelector(state => state.authState.userData);
    const [viewData, setViewData] = useState([]);

    let _tableColumns = [
        {
            Header: "TITLE",
            accessor: "title"
        },
        {
            Header: "CONTENT",
            accessor: "content",
            style: {
                width: "150px",
                maxWidth: "150px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis"
            }
        },
        {
            Header: "DATE",
            accessor: "createdTime"
        },
        {
            id: "action",
            Header: "",
            Cell: ({ row }) => (
                <div className="btn-group m-r-5 m-b-5">
                    <UncontrolledButtonDropdown>
                        <DropdownToggle caret color="default"><i className="fas fa-cog"></i></DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => { setViewModal(!viewModal); setViewData(row.original) }}><span className="text-primary">{t("VIEW")}</span></DropdownItem>
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                </div>
            ),
            disableSortBy: true,
            disableFilters: true,
            style: { overflow: "visible" }
        }
    ]

    /// <summary>
    /// Author : Yong Sheng Chuan
    /// </summary>
    useEffect(() => {
        init();
    }, [])

    /// <summary>
    /// Author : Yong Sheng Chuan
    /// </summary>
    async function init() {
        var responseJson = await ApiEngine.get(ApiUrl._API_GET_SYSTEM_MESSAGE + "?userId=" + _userData.userId);

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setAnnouncementData(responseJson[ApiKey._API_DATA_KEY]);
        }
        else {
            _dispatch(showResponseMessage(responseJson[ApiKey._API_SUCCESS_KEY], t(responseJson[ApiKey._API_MESSAGE_KEY])));
        }
    }

    return (
        <div>
            <h1 className="page-header">{t("MY_ANNOUNCEMENT")}</h1>
            <Panel>
                <PanelBody>
                    <ReactTable data={announcementData} columns={_tableColumns} />
                </PanelBody>
            </Panel>
            <Modal isOpen={viewModal} centered size={"md"} toggle={() => { setViewModal(!viewModal) }}>
                <ModalHeader toggle={() => { setViewModal(!viewModal) }}>{viewData.title}</ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-lg-12">
                            <textarea class="form-control" rows="5"
                                name="content"
                                value={viewData.content}
                                disabled={true}
                                defaultValue={viewData.content}>
                            </textarea>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-danger" onClick={() => { setViewModal(!viewModal) }}>{t("CLOSE")}</button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default Announcement;